import React from "react";
import "./skeleton.scss";
const Skeleton = ({
  variant = "text",
  children,
  width,
  height,
  className,
  style,
}) => {
  return (
    <span
      className={`skeleton-container ${
        variant === "text" ? "skeleton-container-text" : " "
      } ${
        variant === "circular"
          ? "skeleton-container-circular"
          : ""
      } ${
        !!children ? "skeleton-container-fit-content" : ""
      } ${className}`}
      style={{
        width,
        height,
        ...style,
      }}
    >
      {children}
    </span>
  );
};

export default Skeleton;
